import PropTypes from "prop-types";
import React from "react";
import { CIVILITY, CREDIT_CARDS_TYPES, PAYMENT_OPTIONS } from "app/constants";
import "./PaymentMethodsFieldsetNew.scss";
import { FormattedMessage } from "react-intl";
import PaymentTypeInput from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/PaymentTypeInput";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import CasinoPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/Casino/CasinoPaymentType";
import { paymentTypeShape } from "app/utils/propTypes";
import CreditCardPictos from "app/pages/.shared/CreditCardPictos/CreditCardPictos";

class PaymentMethodsFieldsetNew extends React.PureComponent {
	render() {
		const {
			onChange,
			casino = { mensualiteCasino: {}, forbiddenCause: "" },
			allowedPaymentTypes = [],
			ideal = {},
			onCreditCardInputsBlur,
			onCreditCardInformationChange,
			total,
			mensualite2Fois = {},
			fields = { payment: { type: {} }, contact: { name: { gender: {} } } },
			swissbilling = { forbiddenCause: "", cgvURL: "" },
			showAmountToPay,
			shop,
		} = this.props;

		if (allowedPaymentTypes.length > 1) {
			return (
				<div className="payment-methods-fieldset-new">
					<div>
						{allowedPaymentTypes.map(allowedPaymentType => {
							return (
								<div
									className="payment-methods-fieldset-new__item"
									key={allowedPaymentType.paymentType + allowedPaymentType.terms}
								>
									<PaymentTypeInput
										fields={fields}
										swissbilling={swissbilling}
										total={total}
										mensualite2Fois={mensualite2Fois}
										casino={casino}
										paymentType={allowedPaymentType}
										onChange={onChange}
										ideal={ideal}
										onCreditCardInputsBlur={onCreditCardInputsBlur}
										onCreditCardInformationChange={
											onCreditCardInformationChange
										}
										showAmountToPay={showAmountToPay}
									/>
								</div>
							);
						})}
					</div>
				</div>
			);
		} else if (allowedPaymentTypes.length === 1) {
			let acceptedCreditCardTypes = allowedPaymentTypes[0].acceptedCreditCardTypes;
			if (shop === "fr-FR" && acceptedCreditCardTypes && acceptedCreditCardTypes.length > 0) {
				acceptedCreditCardTypes = [CREDIT_CARDS_TYPES.CB].concat(acceptedCreditCardTypes);
			}
			const creditCardIcons = <CreditCardPictos creditCardCodes={acceptedCreditCardTypes} />;

			if (allowedPaymentTypes[0].terms === PAYMENT_OPTIONS["1x"]) {
				return (
					<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
						<div className="payment-methods-fieldset-new__line">
							<FormattedMessage id="payment.method.adyen_cse_card" />
							{creditCardIcons}
						</div>
						<CreditCardPaymentType
							payNowAmount={total}
							field={fields.payment.card}
							onCreditCardInputsBlur={onCreditCardInputsBlur}
							onCreditCardInformationChange={onCreditCardInformationChange}
							showAmountToPay={showAmountToPay}
						/>
					</div>
				);
			} else if (allowedPaymentTypes[0].terms === PAYMENT_OPTIONS["2x"]) {
				return (
					<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
						<div className="payment-methods-fieldset-new__line">
							<FormattedMessage id="payment.method.adyen_cse_card" />
							{creditCardIcons}
						</div>
						<CreditCardPaymentType
							payNowAmount={mensualite2Fois.payNowAmount}
							payLaterAmount={mensualite2Fois.payLaterAmount}
							dueDate={mensualite2Fois.dueDate}
							field={fields.payment.card}
							onCreditCardInputsBlur={onCreditCardInputsBlur}
							onCreditCardInformationChange={onCreditCardInformationChange}
							showAmountToPay={showAmountToPay}
						/>
					</div>
				);
			} else if (allowedPaymentTypes[0].terms === PAYMENT_OPTIONS["4x"]) {
				return (
					<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
						<div className="payment-methods-fieldset-new__line">
							<FormattedMessage id="payment.method.adyen_cse_card" />
							{creditCardIcons}
						</div>
						<CasinoPaymentType
							onCreditCardInputsBlur={onCreditCardInputsBlur}
							onCreditCardInformationChange={onCreditCardInformationChange}
							field={fields.payment.card}
							payNowAmount={casino.mensualiteCasino.apport}
							showMaidenName={fields.contact.name.gender.value === CIVILITY.FEMALE}
						/>
					</div>
				);
			}
		}

		return false;
	}
}

PaymentMethodsFieldsetNew.propTypes = {
	fields: PropTypes.object,
	onCreditCardInputsBlur: PropTypes.func,
	onCreditCardInformationChange: PropTypes.func,
	onChange: PropTypes.func,
	casino: PropTypes.shape({
		mensualiteCasino: {
			apport: PropTypes.number,
			coutCredit: PropTypes.number,
			mensualite: PropTypes.number,
		},
	}),
	allowedPaymentTypes: PropTypes.arrayOf(paymentTypeShape),
	total: PropTypes.number,
	mensualite2Fois: PropTypes.object,
	swissbilling: PropTypes.object,
	ideal: PropTypes.object,
	showAmountToPay: PropTypes.bool,
	shop: PropTypes.string,
};

export default PaymentMethodsFieldsetNew;
